const PARTNER_NOTE = {
  PRE_ENROLMENT: "not enrolled yet",
  INVITED: "invited",
  ONBOARDING: "enrolling",
};

const joinNote = (email, note) => [email, note].filter(Boolean).join(" · ");

/**
 * Everyone a custom referrer label can be linked to, keyed by user id because that is what the
 * link endpoint takes: name-matched suggestions first, then referral partners, then staff. Each
 * person appears once. A partner with no login account has no user id, so it cannot be linked.
 */
export const buildLinkCandidates = ({ suggestions = [], users = [], partners = [] }) => {
  const seen = new Set();
  const take = (option) => {
    if (option.userId == null || seen.has(option.userId)) return null;
    seen.add(option.userId);
    return option;
  };

  const suggested = suggestions.map((s) =>
    take({
      userId: s.userId,
      label: s.name,
      sublabel: joinNote(s.email, s.exact ? "" : "partial match"),
      group: "Suggested",
    })
  );
  const partnerOptions = partners.map((p) =>
    take({
      userId: p.userId,
      label: p.displayName,
      sublabel: joinNote(p.email, PARTNER_NOTE[p.status]),
      group: "Referral partners",
    })
  );
  const staffOptions = users
    // A partner's login is a REFERRAL_USER; their partner row above is the one to offer.
    .filter((u) => u.type !== "REFERRAL_USER")
    .map((u) =>
      take({ userId: u.id, label: u.name || u.email, sublabel: u.email, group: "Staff" })
    );

  return [...suggested, ...partnerOptions, ...staffOptions].filter(Boolean);
};
